<template>
    <div class="cabinet-content-wrap">
        <HeaderPublic />
        <div v-if="product">
            <section class="cabinet__breadcrumbs">
                <router-link to="/" class="cabinet__breadcrumbs-link"
                    >Главная</router-link
                >
                <span class="cabinet__breadcrumbs-arrow">&rsaquo;</span>
                <router-link
                    to="/account/catalog"
                    class="cabinet__breadcrumbs-link"
                    >Каталог</router-link
                >
                <span class="cabinet__breadcrumbs-arrow">&rsaquo;</span>
                <template v-if="product.main_display_category">
                    <template v-if="product.main_display_category.parent">
                        <router-link
                            :to="{
                                name: 'RetailerCategoryID',
                                params: { id: product.main_display_category.parent.url }
                            }"
                            class="cabinet__breadcrumbs-link"
                            >{{ product.main_display_category.parent.name }}</router-link
                        >
                        <span class="cabinet__breadcrumbs-arrow">&rsaquo;</span>
                    </template>
                    <router-link
                        :to="{
                            name: 'RetailerCategoryID',
                            params: {
                                id: product.main_display_category.url,
                            }
                        }"
                        class="cabinet__breadcrumbs-link"
                        >{{ product.main_display_category.name }}</router-link
                    >
                    <span class="cabinet__breadcrumbs-arrow">&rsaquo;</span>
                </template>
                <a
                    v-if="product.brand.subdomain_url"
                    :href="product.brand.subdomain_url"
                    class="cabinet__breadcrumbs-link"
                    >{{ product.brand.BrandName }}</a
                >
                <router-link
                    v-else
                    :to="{
                        name: 'RetailerBrandsID',
                        params: { id: product.BrandID }
                    }"
                    class="cabinet__breadcrumbs-link"
                    >{{ product.brand.BrandName }}</router-link
                >
            </section>
            <div
                class="cabinet-product-card cabinet-product-card--supplier d-flex flex-column flex-lg-row"
            >
                <a
                    v-show="routeFrom && routeFrom.name"
                    href="javascript:void(0)"
                    class="cabinet-product-back cabinet-btn--back"
                    @click="$router.go(-1)"
                ></a>

                <section
                    class="cabinet-product-detail d-flex flex-column flex-md-row justify-content-md-between w-100"
                >
                    <div class="cabinet-product-left">
                        <image-swiper :images="product.images" />

                        <div v-if="isMobile" class="d-md-none pt-4">
                            <h2 class="h2 cabinet-title pt-1">
                                {{ product.Name || product.type.Name }}
                            </h2>
                            <div class="subtitle1 pt-2" v-if="product.price_expired == false">
                                <div v-if="product.Price > 0">
                                    {{ getFormattedNum(product.Price || 0) }}
                                    ₽{{ priceUnit }}
                                </div>
                                <div v-else>
                                    Цена не указана
                                </div>
                            </div>
                            <div class="pt-3 d-flex">
                                <button
                                    v-if="!inCart"
                                    class="cabinet-btn"
                                    @click.prevent="addProductToCart"
                                >
                                    Добавить в корзину
                                </button>
                                <div
                                    v-else
                                    class="cabinet-product-detail__add-to-cart cabinet__catalog-form d-flex align-items-center mt-0"
                                >
                                    <button
                                        class="cabinet__catalog-form_minus"
                                        @click="decreaseQuantityInCart"
                                    />
                                    <input
                                        type="text"
                                        class="cabinet__catalog-form_input cabinet-form-group__input"
                                        :value="inCartQuantity"
                                        @change="onInCartQuantityInput"
                                    />
                                    <button
                                        class="cabinet__catalog-form_plus"
                                        @click="increaseQuantityInCart"
                                    />
                                </div>
                                <div
                                    class="cabinet-product-detail__favorite cabinet-table__favorite ml-3 pl-1"
                                >
                                    <div
                                        class="cabinet-btn-icon cabinet-btn-icon--favorite js-add-to-favorite"
                                        :class="{ active: isFavourite }"
                                        @click.prevent="onClickFavourite"
                                    ></div>
                                    <div
                                        v-if="isListOpened"
                                        v-click-outside="closeLists"
                                        class="cabinet__catalog-favorite_list"
                                    >
                                        <div
                                            v-for="list of lists(productLists)"
                                            :key="list.ListID"
                                            class="cabinet__catalog-favorite_list-item"
                                        >
                                            <label class="app-checkbox">
                                                <input
                                                    type="checkbox"
                                                    :value="list.ListID"
                                                    :checked="list.checked"
                                                    @click.prevent="
                                                        onClickList(
                                                            list.ListID,
                                                            list.checked
                                                        )
                                                    "
                                                />
                                                <span
                                                    class="app-checkbox__checkmark"
                                                ></span>
                                                {{ list.ListName }}
                                            </label>
                                        </div>
                                        <div
                                            class="cabinet__catalog-favorite_list-item d-flex align-items-center"
                                        >
                                            <label
                                                class="app-checkbox"
                                                :class="{
                                                    disabled: !newListName
                                                }"
                                            >
                                                <input
                                                    type="checkbox"
                                                    :disabled="!newListName"
                                                    @change="
                                                        addNewList(newListName)
                                                    "
                                                />
                                                <span
                                                    class="app-checkbox__checkmark"
                                                ></span>
                                            </label>
                                            <input
                                                v-model="newListName"
                                                type="text"
                                                class="cabinet-form-group__input"
                                                placeholder="Создать новый"
                                                @keypress.enter="
                                                    addNewList(newListName)
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            v-if="product.sets.length"
                            class="pt-4 mt-4 garniture garniture--supplier"
                        >
                            <div class="d-flex align-items-center">
                                <div class="subtitle1">Гарнитур</div>
                                <p
                                    class="caption mb-0 pl-2 pt-1 text-gray garniture__number"
                                >
                                    {{ product.sets[0].set_article }}
                                </p>
                            </div>
                            <div
                                v-if="itemsInSet.length"
                                class="garniture__list d-flex flex-wrap align-items-center"
                            >
                                <div
                                    v-for="itemInSet in itemsInSet"
                                    :key="itemInSet.item_id"
                                    class="garniture__item"
                                >
                                    <router-link
                                        :to="{
                                            name: 'RetailerProductID',
                                            params: { id: itemInSet.item_id }
                                        }"
                                    >
                                        <img
                                            :src="
                                                itemInSet.item.images.length
                                                    ? itemInSet.item.images[0]
                                                          .url
                                                    : ''
                                            "
                                            alt=""
                                        />
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="cabinet-product-right">
                        <div v-if="!isMobile" class="d-none d-md-block">
                            <h2 class="h2 cabinet-title pt-1">
                                {{ product.Name || product.type.Name }}
                            </h2>
                            <div class="subtitle1 pt-2" v-if="product.price_expired == false">
                                <div v-if="product.Price > 0">
                                    {{ getFormattedNum(product.Price || 0) }}
                                    ₽{{ priceUnit }}
                                </div>
                                <div v-else>
                                    Цена не указана
                                </div>
                            </div>
                            <div class="pt-3 d-flex">
                                <button
                                    v-if="!inCart"
                                    class="cabinet-btn"
                                    @click.prevent="addProductToCart"
                                >
                                    Добавить в корзину
                                </button>
                                <div
                                    v-else
                                    class="cabinet-product-detail__add-to-cart cabinet__catalog-form d-flex align-items-center mt-0"
                                >
                                    <button
                                        class="cabinet__catalog-form_minus"
                                        @click="decreaseQuantityInCart"
                                    />
                                    <input
                                        type="text"
                                        class="cabinet__catalog-form_input cabinet-form-group__input"
                                        :value="inCartQuantity"
                                        @change="onInCartQuantityInput"
                                    />
                                    <button
                                        class="cabinet__catalog-form_plus"
                                        @click="increaseQuantityInCart"
                                    />
                                </div>
                                <div
                                    class="cabinet-product-detail__favorite cabinet-table__favorite ml-3 pl-1"
                                >
                                    <div
                                        class="cabinet-btn-icon cabinet-btn-icon--favorite js-add-to-favorite"
                                        :class="{ active: isFavourite }"
                                        @click.prevent="onClickFavourite"
                                    ></div>
                                    <div
                                        v-if="isListOpened"
                                        v-click-outside="closeLists"
                                        class="cabinet__catalog-favorite_list"
                                    >
                                        <div
                                            v-for="list of lists(productLists)"
                                            :key="list.ListID"
                                            class="cabinet__catalog-favorite_list-item"
                                        >
                                            <label class="app-checkbox">
                                                <input
                                                    type="checkbox"
                                                    :value="list.ListID"
                                                    :checked="list.checked"
                                                    @click.prevent="
                                                        onClickList(
                                                            list.ListID,
                                                            list.checked
                                                        )
                                                    "
                                                />
                                                <span
                                                    class="app-checkbox__checkmark"
                                                ></span>
                                                {{ list.ListName }}
                                            </label>
                                        </div>
                                        <div
                                            class="cabinet__catalog-favorite_list-item d-flex align-items-center"
                                        >
                                            <label
                                                class="app-checkbox"
                                                :class="{
                                                    disabled: !newListName
                                                }"
                                            >
                                                <input
                                                    type="checkbox"
                                                    :disabled="!newListName"
                                                    @change="
                                                        addNewList(newListName)
                                                    "
                                                />
                                                <span
                                                    class="app-checkbox__checkmark"
                                                ></span>
                                            </label>
                                            <input
                                                v-model="newListName"
                                                type="text"
                                                class="cabinet-form-group__input"
                                                placeholder="Создать новый"
                                                @keypress.enter="
                                                    addNewList(newListName)
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mt-4">
                            <cabinet-tabs :tabs="tabs">
                                <product-specifications
                                    slot="0"
                                    :product="product"
                                />
                                <product-inserts slot="1" :product="product" />
                                <product-description
                                    slot="2"
                                    :description="product.Description"
                                />
                            </cabinet-tabs>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <div v-else-if="this.error">
            <div class="error text-center">
                <div class="error-image">
                    <img src="/img/icons/error.svg" alt="" />
                </div>
                <div class="error-title">
                    Упс! Что-то пошло не так.
                </div>
                <div class="error-button">
                    <button
                        type="button"
                        class="cabinet-btn"
                        @click="getProduct"
                    >
                        Попробовать еще раз
                    </button>
                </div>
            </div>
        </div>

        <p v-else class="mt-3">Loading...</p>
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import vClickOutside from 'v-click-outside'

import CabinetTabs from '@/components/Cabinet/Tabs'
import getNameById from '@/mixins/getNameById'
import checkDemoUser from '@/mixins/checkDemoUser.js'
import onResize from '@/mixins/on-resize.js'
import getFormattedNum from '@/utils/getFormattedNum'
import ProductSpecifications from '@/components/Cabinet/Product/Specifications'
import ProductDescription from '@/components/Cabinet/Product/Description'
import ProductInserts from '@/components/Cabinet/Product/Inserts'
import ImageSwiper from '@/components/Cabinet/Retailer/Product/Detail/DetailSwiper.vue'
import HeaderPublic from '@/components/Public/PublicHeader'

export default {
    name: 'RetailerCatalogProductID',
    directives: {
        clickOutside: vClickOutside.directive
    },
    components: {
        ProductSpecifications: ProductSpecifications,
        ProductInserts: ProductInserts,
        ProductDescription: ProductDescription,
        CabinetTabs,
        ImageSwiper,
        HeaderPublic
    },
    mixins: [getNameById, checkDemoUser, onResize],
    data() {
        return {
            product: null,
            isListOpened: false,
            productLists: null,
            newListName: '',
            isFavourite: false,
            productID: parseInt(this.$route.params.id, 10),
            inCartQuantity: 0,
            cartLoader: false,
            imageGallery: null,
            imageThumbs: null,
            error: false,
            routeFrom: {}
        }
    },
    computed: {
        ...mapState('other', ['priceUnitOptions']),
        ...mapState('types', { types: 'supplierTypes' }),
        ...mapState('retailerProducts', ['errors']),
        ...mapGetters('retailerLists', { lists: 'productListsForCheck' }),
        ...mapGetters('cart', ['productInCart']),
        ...mapState('retailerSets', ['itemsInSet']),
        priceUnit() {
            const unit = this.getNameById(
                this.priceUnitOptions,
                'abbr',
                'id',
                this.product.PriceUnit
            )

            return unit ? `/${unit}` : ''
        },
        inCart() {
            return !!this.productInCart(this.productID)
        },
        cartProduct() {
            return this.productInCart(this.productID)
        },
        tabs() {
            let tabs = ['Характеристики', 'Вставки']
            if (this.product && this.product.Description) {
                tabs.push('Описание')
            }
            return tabs
        }
    },
    created() {
        this.getCart()
        this.getLists()
        this.getCollections()
        this.getTechnologies()
        this.getColors()
        this.getInsertMaterials()
        this.getInsertColors()
        this.getInsertFacets()
        this.getProduct()
    },
    mounted() {
        this.$nextTick(() => {
            window.$('.select-list').selectpicker({
                title: 'Список №1',
                width: '260px'
            })
        })
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.routeFrom = from
        })
    },
    methods: {
        ...mapActions('cart', [
            'getCart',
            'addToCart',
            'deleteFromCart',
            'changeItemQuantity'
        ]),
        ...mapActions('retailerLists', ['getLists']),
        ...mapActions('cart', ['addToCart', 'deleteFromCart']),
        ...mapActions('collections', ['getCollections']),
        ...mapActions('technologies', ['getTechnologies']),
        ...mapActions('colors', ['getColors']),
        ...mapActions('insert', [
            'getInsertMaterials',
            'getInsertColors',
            'getInsertFacets'
        ]),
        ...mapActions('retailerSets', ['getItemsInSet']),
        getProduct() {
            this.error = false
            this.$axios
                .get(`/retailer/items/${this.$route.params.id}`)
                .then(async res => {
                    this.product = res.data
                    this.productLists = res.data.save_lists
                    this.isFavourite = !!res.data.save_lists.length
                    this.inCartQuantity = this.inCart
                        ? this.cartProduct.pivot.Quantity
                        : 0

                    if (this.product.sets.length) {
                        await this.getItemsInSet({
                            setID: this.product.sets[0].set_id
                        })
                    }
                })
                .catch(() => {
                    this.error = true
                })
        },
        getProductNoTrack() {
            this.error = false
            this.$axios
                .get(`/retailer/items/${this.$route.params.id}?notrack=1`)
                .then(async res => {
                    this.product = res.data
                    this.productLists = res.data.save_lists
                    this.isFavourite = !!res.data.save_lists.length
                    this.inCartQuantity = this.inCart
                        ? this.cartProduct.pivot.Quantity
                        : 0

                    if (this.product.sets.length) {
                        await this.getItemsInSet({
                            setID: this.product.sets[0].set_id
                        })
                    }
                })
                .catch(() => {
                    this.error = true
                })
        },
        addProductToCart() {
            if (this.isDemoUserMode()) return

            this.cartLoader = true

            this.addToCart(this.productID)
                .then(() => {
                    this.getCart()
                    this.inCartQuantity = 1
                })
                .finally(() => {
                    this.cartLoader = false
                })
        },
        removeProductFromCart() {
            this.cartLoader = true

            this.deleteFromCart(this.productID)
                .then(() => {
                    this.getCart()
                    this.inCartQuantity = 0
                })
                .finally(() => {
                    this.cartLoader = false
                })
        },
        increaseQuantityInCart() {
            this.inCartQuantity++
            this.changeQuantityInCart()
        },
        decreaseQuantityInCart() {
            if (this.inCartQuantity > 1) {
                this.inCartQuantity--
                this.changeQuantityInCart()
            } else {
                this.removeProductFromCart()
            }
        },
        onInCartQuantityInput(e) {
            let val = e.target.value
            this.inCartQuantity = parseInt(val.replace(/\D/g, '') || 0)
            e.target.value = this.inCartQuantity
            if (this.inCartQuantity >= 1) {
                this.changeQuantityInCart()
            } else {
                this.removeProductFromCart()
            }
        },
        changeQuantityInCart() {
            if (this.quantityTimer) {
                clearInterval(this.quantityTimer)
            }

            this.quantityTimer = setTimeout(() => {
                this.changeItemQuantity({
                    productID: this.productID,
                    quantity: this.inCartQuantity,
                    comment: this.cartProduct.pivot.Comment
                })
            }, 1000)
        },
        getFormattedNum(num) {
            return getFormattedNum(num)
        },
        clearNewListName() {
            this.newListName = ''
        },
        closeLists() {
            this.isListOpened = false
            this.clearNewListName()
        },
        openLists() {
            this.isListOpened = true
            this.getProductNoTrack()
        },
        getProductLists() {
            return this.$axios
                .get(`/retailer/items/${this.productID}?notrack=1`)
                .then(({ data }) => {
                    this.productLists = data.save_lists
                })
        },
        onClickList(listID, isChecked) {
            const query = []

            if (isChecked) {
                query.push(this.removeFromList(listID))
            } else {
                query.push(this.addToList(listID))
            }

            Promise.all(query).then(() => {
                this.getProductLists()
                this.getProductNoTrack()
            })
        },
        onClickFavourite() {
            if (this.isDemoUserMode()) return

            if (!this.isFavourite) {
                this.addToDefaultList()
                    .then(() => {
                        this.getProductLists()
                    })
                    .then(() => {
                        this.openLists()
                    })
            } else {
                this.openLists()
            }
        },
        addToDefaultList() {
            return this.$axios.post(
                `/retailer/items/${this.productID}/default-list`
            )
        },
        addToList(listID) {
            return this.$axios.post(
                `/retailer/items/${this.productID}/list/${listID}`
            )
        },
        removeFromList(listID) {
            return this.$axios.delete(
                `/retailer/items/${this.productID}/list/${listID}`
            )
        },
        addNewList(listName) {
            this.$axios
                .post('/retailer/lists', {
                    ListName: listName
                })
                .then(({ data }) => {
                    const newListID = data.ListID

                    this.clearNewListName()
                    this.addToList(newListID)
                        .then(() => {
                            this.getProductLists()
                        })
                        .then(() => {
                            this.getLists()
                        })
                })
        }
    }
}
</script>
